import { styled } from '@/stitches.config';

import { Box } from '@base-app';
import { ReactComponent as ArrowLeft } from '@assets/icons/arrow-left.svg';

export const StyledSubPage = styled(Box, {
  padding: '0 $6',
  margin: '0 auto',
  maxWidth: '$studyInsights$containerMaxWidth',
});

export const StyledButtonContainer = styled(Box, {
  alignItems: 'strech',
  backgroundColor: '$white',
  display: 'flex',
  gap: '$6',
  margin: '0 0 $8 0',
});

export const ArrowLeftIcon = styled(ArrowLeft, {
  height: '$6',
  width: '$6',
});

export const StyledPageLargeTitle = styled(Box, {
  color: '$darkBlue300',
  display: 'flex',
  fontSize: '$3xl',
  fontWeight: '$bold',
  marginBottom: '$8',
});
